import React, { useMemo } from 'react';
import { SharePanelFormSection } from './section';

const SharePanelFormUTMParamsSectionLink = () => {

  const subtitle: string = useMemo(() => {

    return 'Configure UTM parameters for tracking';
  }, []);

  return <SharePanelFormSection type='utm-params' title='UTM Parameters' subTitle={subtitle} />;
};

export default SharePanelFormUTMParamsSectionLink; 